import axios from "axios"

import { useNavigate } from "react-router-dom";
import { useState, useEffect } from 'react';
import {Spinner} from '../Components/Spinner.jsx'
import { API_URI} from '../config/constants.js';
import { useUser } from "../Contexts/UserContext.jsx";
import { useModal } from "../Contexts/ModalContext";

export function Logout() {
  const navigate = useNavigate();
  const { closeUserSession } = useUser();
  const [showSpinner, setShowSpinner] = useState(false);
  const {showModal} = useModal();

  function getUserSessionId() {
    return sessionStorage.getItem("User-Session-ID");
  }

  useEffect(() => {
      const logoutUser = async () => {
        setShowSpinner(true);
        try {
          let userSessionId = getUserSessionId();
          setShowSpinner(true);
          await axios.post(API_URI + "/user/logout", {userSessionId}, { withCredentials: true })
            .then((response) => {
              console.log("INFO: Response received for logout endpoint ");
              closeUserSession();
              showModal("User Logged out.");
              navigate("/home");
            });
        }  
        catch (err) {
          setShowSpinner(false);
          console.log("ERROR: upon calling logout endpoint" + err);
          navigate("/error");
        }
        finally {
          setShowSpinner(false);
        }
      };

      logoutUser();
    }, [] // Empty Dependency Array - 
          // Executed only once when the page launches but not on every re-render
  );  
  
  return (
    <>
    <Spinner show={showSpinner}/>
    </>
  )
}
